import React from 'react'
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { formatNumber, formatPercent } from '../../../utilities/dashboard'
import ChartTooltip from './ChartTooltip'
import useChartColors from './useChartColors'

// Percentual fora da fatia, na cor do texto (nunca na cor da série)
const SliceLabel = ({ x, y, textAnchor, payload }) => {
  const { chart: colors } = useChartColors()
  return (
    <text x={x} y={y} dy={4} textAnchor={textAnchor} fill={colors.ink} fontSize={12} fontWeight={600}>
      {formatPercent(payload?.percent)}
    </text>
  )
}

// Total no centro da rosca (o recharts passa o centro da pizza ou a área do gráfico, conforme a versão)
const CenterLabel = ({ viewBox, total }) => {
  const { chart: colors } = useChartColors()
  if (!viewBox) return null
  const cx = Number.isFinite(viewBox.cx) ? viewBox.cx : viewBox.x + (viewBox.width / 2)
  const cy = Number.isFinite(viewBox.cy) ? viewBox.cy : viewBox.y + (viewBox.height / 2)
  if (!Number.isFinite(cx) || !Number.isFinite(cy)) return null

  return (
    <g>
      <text x={cx} y={cy - 2} textAnchor='middle' fill={colors.ink} fontSize={18} fontWeight={600}>{formatNumber(total)}</text>
      <text x={cx} y={cy + 15} textAnchor='middle' fill={colors.tick} fontSize={11}>{total === 1 ? 'paciente' : 'pacientes'}</text>
    </g>
  )
}

const tooltipFor = (row) => ({
  title: row.label,
  rows: [{ color: row.color, value: formatNumber(row.total), label: `pacientes (${formatPercent(row.percent)})` }],
})

// Sexo: rosca com as fatias que têm paciente; a legenda mostra todas as opções do cadastro, com número e %
const SexChart = ({ rows, total }) => {
  const { chart: colors } = useChartColors()
  const visible = rows.filter((row) => row.total > 0)

  return (
    <div className='dashboard-sex'>
      <div className='dashboard-sex-chart'>
        <ResponsiveContainer width='100%' height={210}>
          <PieChart margin={{ top: 8, right: 8, bottom: 8, left: 8 }}>
            <Pie
              data={visible}
              dataKey='total'
              nameKey='label'
              innerRadius='52%'
              outerRadius='78%'
              startAngle={90}
              endAngle={-270}
              stroke={colors.surface}
              strokeWidth={2}
              label={<SliceLabel />}
              labelLine={false}
              isAnimationActive={false}
            >
              {visible.map((row) => <Cell key={row.key} fill={row.color} />)}
              <Label position='center' content={<CenterLabel total={total} />} />
            </Pie>
            <Tooltip content={<ChartTooltip render={tooltipFor} />} isAnimationActive={false} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <ul className='dashboard-sex-legend'>
        {rows.map((row) => (
          <li key={row.key} className={row.total ? '' : 'dashboard-muted'}>
            <i className='dashboard-swatch' style={{ background: row.color }} aria-hidden='true' />
            <span className='dashboard-sex-name'>{row.label}</span>
            <b className='dashboard-num'>{formatNumber(row.total)}</b>
            <span className='dashboard-num'>{row.percent === null ? '—' : formatPercent(row.percent)}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SexChart
